<div class="pt-transaction-text-total">
  {{ ('transactionDonutTotal.header.' + chart().id) | translate }}

  <div class="pt-transaction-text-total__sum">
    {{ total() }}
    <pt-coin/>
  </div>
</div>
